import * as yup from 'yup';
import { ERROR_MESSAGES } from 'utils/form';

const imageGallerySchema = {
  image: yup
    .mixed()
    .nullable()
    .when('_destroy', {
      is: true,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required(ERROR_MESSAGES.required),
    }),
  description: yup.string().nullable().notRequired(),
  _destroy: yup.boolean().notRequired(),
};

const imageGalleryDefaultValues = [{ image: null, description: '', position: 0 }];

export { imageGallerySchema, imageGalleryDefaultValues };
